import { type FC } from "react";

// TODO: React内で完結するように修正する。https://rejob.backlog.jp/view/REJOB_DEV_DOING-13410
export const ScoutReceivePopUp: FC = () => {
  return (
    <>
      <div
        className="c-bottom-modal p-scout-off-user-modal js-scout-off-user-modal"
        data-ga-action="scout_flag_modal"
      >
        <div className="c-bottom-modal__header">
          <h1 className="c-bottom-modal__title">スカウトがOFFになっています。</h1>
        </div>
        <div className="c-bottom-modal__content">
          <div className="p-scout-off-user-modal__top">
            <p className="p-scout-off-user-modal__title">
              スカウトを受け取って、
              <br />
              転職をスムーズにしませんか？
            </p>
            <img
              src="/images/user_frontend/global/img_appeal_for_scout_off_user.png"
              alt=""
              width={96}
              height={62}
              loading="lazy"
            />
          </div>
          <p className="u-mt16">
            特定の企業からのスカウトをブロックしたい場合は、マイページから設定できます。
          </p>
          <div className="p-scout-off-user-modal-btn-area">
            <p className="p-scout-off-user-modal-btn-area__item">
              <button
                type="button"
                className="c-btn p-scout-off-user-modal__submit js-scout-off-user-modal__submit"
                data-ga-action="scout_flag_modal_on"
              >
                スカウトを受け取る
              </button>
            </p>
            <p className="p-scout-off-user-modal-btn-area__item">
              <button
                type="button"
                className="p-scout-off-user-modal__cancel js-scout-off-user-modal-close"
              >
                今は受け取らない
              </button>
            </p>
          </div>
        </div>
      </div>
      <div className="p-scout-off-user-modal-overlay js-scout-off-user-modal-overlay" />
      <div className="p-scout-off-user-toast js-scout-off-user-toast">
        <p className="p-scout-off-user-toast__icon">
          <i className="icon-paper-plane" />
        </p>
        <p className="p-scout-off-user-toast__text">スカウトを受け取れるようになりました</p>
      </div>
    </>
  );
};
